// extracted by mini-css-extract-plugin
export default {"symbolTabList":"SymbolTabs_symbolTabList__Ladan","content":"Content_content__Z4v+F","content_expanded":"Content_content_expanded__du48H"};